import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';

import CSPRow, { CSPCardFragment } from '@reverbdotcom/commons/src/components/csp_row';

import { CoreRecommendedCspsRow } from '@reverbdotcom/commons/src/gql/graphql';
import { compact, uniqBy } from 'lodash';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { showLocalizedListingContent } from '@reverbdotcom/commons/src/localize_listing_rows_utils';

export function RecommendedCspsRow(props: ChildProps<{}, CoreRecommendedCspsRow.Query>) {
  const user = useUser();

  const loading = !!props.data?.loading;
  const csps = compact(props.data?.me?.recommendedListings?.listings?.map(listing => listing.csp));
  const recommendedCsps = uniqBy(csps, csp => csp.id);

  const canView = !!recommendedCsps.length;

  useViewTracking({
    componentName: 'RecommendedCspsRow',
    eventName: MParticleEventName.ComponentView,
  }, canView);

  if (!canView) return null;

  return (
    <CSPRow
      title={I18n.t('discovery.recommendedProducts')}
      csps={recommendedCsps}
      loading={loading}
      hidePrices={showLocalizedListingContent(user)}
    />
  );
}

const withQuery = withGraphql<{}, CoreRecommendedCspsRow.Query>(
  gql`
    query Core_RecommendedCspsRow {
      me {
        uuid

        recommendedListings(
          input: {
            limit: 5
          }
        ) {
          listings {
            _id
            csp {
              _id
              ...CSPCard
            }
          }
        }
      }
    },
    ${CSPCardFragment},
  `,
  {
    options: () => {
      return {
        ssr: false,
        variables: {},
      };
    },
  },
);

export default withQuery(RecommendedCspsRow);
